// extracted by mini-css-extract-plugin
export var header = "_v0-1";
export var maskBottom = "_v0-6";
export var maskMiddle = "_v0-7";
export var maskTop = "_v0-5";
export var root = "_v0-0";
export var scrollDownButton = "_v0-3";
export var scrollDownButtonHidden = "_v0-4";
export var viewport = "_v0-2";